import ConfigsService from 'commons-core-services/services/ConfigsService/ConfigsService.js';
import ContentZonesService from 'commons-core-services/services/ContentZonesService/ContentZonesService.js';
import EmailService from 'commons-core-services/services/EmailService/EmailService.js';
import HTTPService from 'commons-core-services/services/HTTPService/HTTPService.js';
import LocaleService from 'commons-core-services/services/LocaleService/LocaleService.js';
import StorageService from 'commons-core-services/services/StorageService/StorageService.js';
import TokenService from 'commons-core-services/services/TokenService/TokenService.js';
import UrlService from 'commons-core-services/services/UrlService/UrlService.js';
import WindowProxy from 'commons-core-services/services/WindowProxy/WindowProxy.js';
import ShowroomPublicTokenService from 'commons-core-services/services/ShowroomPublicTokenService';

import ContentZone from 'commons-core-services/models/ContentZone.js';

export {
    ConfigsService,
    ContentZone,
    ContentZonesService,
    EmailService,
    HTTPService,
    LocaleService,
    StorageService,
    TokenService,
    UrlService,
    WindowProxy,
    ShowroomPublicTokenService,
};

export default {
    ConfigsService,
    ContentZone,
    ContentZonesService,
    EmailService,
    HTTPService,
    LocaleService,
    StorageService,
    TokenService,
    UrlService,
    WindowProxy,
    ShowroomPublicTokenService,
};

/**
 * @external {Window} https://developer.mozilla.org/en-US/docs/Web/API/Window
 */

/**
 * @external {WebStorage} https://developer.mozilla.org/en/docs/Web/API/Storage
 */

/**
 * @external {LocalStorage} https://developer.mozilla.org/en/docs/Web/API/Window/localStorage
 */

/**
 * @external {SessionStorage} https://developer.mozilla.org/en/docs/Web/API/Window/sessionStorage
 */
